import { all, takeLatest } from 'redux-saga/effects';

import { PecasTypes } from '../ducks/pecas';
import {
  getPecas,
  searchPecas,
  clearPecas,
  finishOrcamento,
  createCart,
  updateCart,
  handleQtdItemSync,
  handleClearItemQtdSync,
  handleFormPgmtSync,
} from './pecas';

import { ClientTypes } from '../ducks/client';
import {
  clientVerify,
  createClient,
  getClientInfo,
  userLogin,
  getPedidos,
  passwordResetRequest,
  accontTokenVerify,
  passwordTokenVerify,
  newPassword,
  newIssues,
} from './client';

export default function* rootSaga() {
  yield all([
    takeLatest(PecasTypes.GET_PECAS_REQUEST, getPecas),
    takeLatest(PecasTypes.GET_SEARCH_PECAS_REQUEST, searchPecas),
    takeLatest(PecasTypes.CLEAR_SEARCH_PECAS_REQUEST, clearPecas),
    takeLatest(PecasTypes.FINISH_ORCAMENTO_REQUEST, finishOrcamento),
    takeLatest(PecasTypes.GET_CARD_DATA_REQUEST, createCart),
    takeLatest(PecasTypes.UPDATE_CARD_DATA_REQUEST, updateCart),
    takeLatest(PecasTypes.HANDLE_ITEM_QTD_REQUEST, handleQtdItemSync),
    takeLatest(PecasTypes.HANDLE_CLEAR_ITEM_QTD_REQUEST, handleClearItemQtdSync),
    takeLatest(PecasTypes.HANDLE_FORM_PGT_REQUEST, handleFormPgmtSync),
    takeLatest(ClientTypes.RESET_PASSWORD_REQUEST, passwordResetRequest),
    takeLatest(ClientTypes.PASSWORD_TOKEN_VERIFY_REQUEST, passwordTokenVerify),
    takeLatest(ClientTypes.ACCONT_TOKEN_VERIFY_REQUEST, accontTokenVerify),
    takeLatest(ClientTypes.CREATE_ISSUES_REQUEST, newIssues),
    takeLatest(ClientTypes.NEW_PASSWORD_REQUEST, newPassword),
    takeLatest(ClientTypes.VERIFY_CLIENT_EXIST_REQUEST, clientVerify),
    takeLatest(ClientTypes.CREATE_CLIENT_REQUEST, createClient),
    takeLatest(ClientTypes.GET_CLIENT_INFO_REQUEST, getClientInfo),
    takeLatest(ClientTypes.GET_PEDIDOS_CLIENT_REQUEST, getPedidos),
    takeLatest(ClientTypes.USER_LOGIN_REQUEST, userLogin),
  ]);
}
